import React from 'react'
import { Info } from 'lucide-react'
import { useEnergyStore } from '@/stores/useEnergyStore'

interface SwitchProps {
  label: string
  enabled: boolean
  onChange: (enabled: boolean) => void
  darkMode?: boolean
  description?: string
  helpKey?: string
}

export const Switch: React.FC<SwitchProps> = ({
  label,
  enabled,
  onChange,
  darkMode = true,
  description,
  helpKey,
}) => {
  const openHelpToItem = useEnergyStore((s) => s.openHelpToItem)
  return (
    <div className="flex items-center justify-between group py-1">
      <div className="flex flex-col">
        <div className="flex items-center gap-1">
          {helpKey && (
            <button
              onClick={() => openHelpToItem(helpKey)}
              className={`shrink-0 p-0.5 rounded-full transition-colors cursor-pointer ${
                darkMode ? 'text-slate-600 hover:text-emerald-500' : 'text-slate-400 hover:text-emerald-600'
              }`}
              title={`Help with ${label}`}
            >
              <Info size={10} />
            </button>
          )}
          <span
            className={`text-[10px] font-black uppercase tracking-wider leading-tight transition-colors ${
              darkMode ? 'text-slate-500 group-hover:text-slate-300' : 'text-slate-400 group-hover:text-slate-600'
            }`}
          >
            {label}
          </span>
        </div>
        {description && (
          <span className={`text-[10px] ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
            {description}
          </span>
        )}
      </div>
      <button
        onClick={() => onChange(!enabled)}
        className={`w-11 h-6 rounded-full relative transition-all duration-300 ease-in-out shadow-inner ${
          enabled
            ? 'bg-emerald-500 shadow-emerald-600/20'
            : darkMode
            ? 'bg-slate-700 shadow-black/20'
            : 'bg-slate-200 shadow-slate-300/50'
        }`}
      >
        <div
          className={`absolute top-1 left-1 w-4 h-4 rounded-full transition-all duration-300 transform bg-white shadow-sm ${
            enabled ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </button>
    </div>
  )
}

